module.exports = __webpack_public_path__ + "img/icon_fast_delivery@2x.de57418.webp";